module.exports = __webpack_public_path__ + "img/weather_sun.e7327abf.png";